import TsaAgreementPreviewDialog from '@/components/AgreementPreviewDialog/index.vue'
let $vm

const plugin = {
  install (vue, pluginOptions = {}) {
    const AgreementPreviewDialog = vue.extend(TsaAgreementPreviewDialog)
    if (!$vm) {
      $vm = new AgreementPreviewDialog({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const agreementPreviewDialog = {
      show (options = {}) {
        $vm.show = true
        $vm.title = options.title || ''
        $vm.url = options.url
      },
      hide () {
        $vm.show = false
        
      }
    }
    if (!vue.prototype.$TsaAgreementPreviewDialog) {
      vue.prototype.$TsaAgreementPreviewDialog = agreementPreviewDialog
    }
  }
}

export default plugin